export default __webpack_public_path__ + "static/media/750x750 whiteCat.b9086597.jpg";